var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.5px",
    height: "82.2px",
    viewBox: "0 0 283.5 82.2",
    style: {
      enableBackground: "new 0 0 283.5 82.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M278,2H5.4C3,2,1.2,4,1.2,6.6v7.6c0,0,0,0,0,0v63.1c0,1.6,1,2.9,2.7,2.9h275.5 c1.7,0,2.8-1.3,2.8-2.9v-4.9c0,0,0,0,0,0V6.6C282.2,4,280.4,2,278,2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M49.1,3.4H5.5c-1.7,0-2.7,1.5-2.7,3.2v65.8c0,1.7,1,3,2.7,3h272.4c1.7,0,2.8-1.3,2.8-3V6.6 c0-1.7-1.1-3.2-2.8-3.2H49.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M102.7,34.9c-1,0.6-2.4,0.8-3.9,0.8c-1,0-2.4,0-3.8-0.2v-1.8c1.2,0.1,2.4,0.2,3.6,0.2 c1,0,2-0.1,2.6-0.4c0.8-0.3,1.2-1.1,1.2-2.1c0-1.3-0.6-1.9-1.9-2.3c-0.8-0.3-1.6-0.5-2.4-0.7c-2-0.6-3.2-1.7-3.2-3.9 c0-1.3,0.5-2.6,1.6-3.3c1.1-0.7,2.3-0.8,3.7-0.8c1,0,2.2,0.1,3.5,0.2v1.7c-1.2-0.1-2.4-0.2-3.3-0.2c-0.9,0-1.7,0-2.3,0.3 c-0.8,0.4-1.1,1.2-1.1,2c0,1.2,0.6,1.8,1.7,2.2c0.7,0.2,1.5,0.4,2.4,0.7c2.2,0.6,3.4,1.7,3.4,4.1 C104.4,32.7,103.9,34.2,102.7,34.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M106.5,25.9c0.8-2,1.4-3.8,1.9-5.7h2.1c-0.6,2.1-1.5,4.1-2.2,5.7H106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M113.3,20.1h2.1v2h-2.1V20.1z M115.2,35.4h-1.8V24.7h1.9L115.2,35.4L115.2,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M126.4,35.4l-0.1-0.6c-1.2,0.4-2.5,0.9-3.8,0.9c-1.2,0-2.2-0.4-3-1.2c-1-1-1.4-2.5-1.4-4.5 c0-2.1,0.7-3.8,1.8-4.7c0.9-0.7,2.1-1,3.5-1c0.9,0,1.9,0.2,2.6,0.5v-4.7h1.9v15.3H126.4z M126.1,33.4v-7c-0.7-0.3-1.6-0.5-2.4-0.5 c-2.4,0-3.6,1.2-3.6,4.1c0,2.9,1.2,4.1,2.9,4.1C124.1,34.1,125.1,33.8,126.1,33.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M135.7,35.8c-1.2,0-2.5-0.3-3.4-1.2c-1-1.1-1.4-2.6-1.4-4.5c0-1.8,0.4-3.5,1.6-4.5 c0.9-0.7,1.9-1.1,3.4-1.1c1.2,0,2.4,0.3,3.3,1.1c1.3,1.1,1.4,2.8,1.4,5h-7.8c0.1,2.5,1.2,3.7,3.3,3.7c1.3,0,2.6-0.3,4.1-0.6v1.5 C138.8,35.4,137.2,35.8,135.7,35.8 M135.8,25.7c-2.1,0-2.8,1.3-2.9,3.4h5.8C138.6,26.9,137.8,25.7,135.8,25.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M151.2,35.4v-6.9c0-1.9-1-2.6-2.6-2.6c-0.9,0-1.9,0.3-3.2,0.7v8.7h-1.9V24.7h1.6l0.1,0.6 c1.3-0.4,2.7-0.9,4-0.9c1.2,0,2.3,0.3,3.1,1.2c0.7,0.8,0.8,1.8,0.8,3v6.9H151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M160.2,35.7c-1.2,0-2.4-0.4-2.9-1.8c-0.3-0.8-0.4-1.8-0.4-2.9v-4.8h-1.8v-1.5h1.8l0.2-3.3h1.7v3.3 h3.2v1.5h-3.2v4.6c0,0.8,0,1.5,0.2,2.1c0.2,0.9,0.7,1.3,1.7,1.3c0.5,0,1.1-0.1,1.6-0.2v1.5C161.6,35.6,160.8,35.7,160.2,35.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M164.8,20.1h2.1v2h-2.1V20.1z M166.7,35.4h-1.8V24.7h1.9L166.7,35.4L166.7,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M177.7,35.4v-9.2h-5v9.2h-1.9v-9.2H169v-1.5h1.8c0-1.6,0.3-2.9,1.3-3.8c0.9-0.8,2.2-1,4-1 c1,0,2,0.1,2.9,0.2v1.6c-0.9-0.1-1.9-0.2-2.9-0.2c-2.8,0-3.4,1-3.4,3.2h6.9v10.8H177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M187.3,35.8c-1.2,0-2.5-0.3-3.4-1.2c-1-1.1-1.4-2.6-1.4-4.5c0-1.8,0.4-3.5,1.6-4.5 c0.9-0.7,1.9-1.1,3.4-1.1c1.2,0,2.4,0.3,3.3,1.1c1.3,1.1,1.4,2.8,1.4,5h-7.8c0.1,2.5,1.2,3.7,3.3,3.7c1.3,0,2.6-0.3,4.1-0.6v1.5 C190.4,35.4,188.8,35.8,187.3,35.8 M187.4,25.7c-2.1,0-2.8,1.3-2.9,3.4h5.8C190.2,26.9,189.4,25.7,187.4,25.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M195.2,35.4V24.7h1.6l0.1,0.7c1.6-0.6,2.5-1,3.8-1h0.2v1.7h-0.4c-1.1,0-1.9,0.2-3.4,0.7v8.7H195.2z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M216.2,35.5l0-0.6c-1.4,0.4-2.6,0.9-3.9,0.9c-0.9,0-1.8-0.2-2.5-0.9c-0.7-0.6-1-1.4-1-2.5 c0-1.1,0.4-2.2,1.5-2.8c0.8-0.4,1.7-0.5,2.8-0.5c0.8,0,1.9,0.1,2.9,0.2v-0.5c0-2.1-0.9-2.8-3.3-2.8c-0.9,0-1.8,0.1-2.7,0.2v-1.5 c1-0.1,2-0.2,3-0.2c1.4,0,2.9,0.1,3.8,1.1c0.9,0.9,1.1,2,1.1,3.6v6.5H216.2z M215.9,30.6c-0.9-0.1-2-0.2-2.8-0.2 c-1.9,0-2.6,0.7-2.6,1.9c0,1.1,0.8,1.9,2.2,1.9c1,0,2.1-0.3,3.2-0.7V30.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#034EA2"
    },
    points: "223.8,35.4 219.6,24.7 221.7,24.7 224.9,33.5 225,33.5 228.2,24.7 230.2,24.7 226,35.4  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M236,35.8c-1.2,0-2.5-0.3-3.4-1.2c-1-1.1-1.4-2.6-1.4-4.5c0-1.8,0.4-3.5,1.6-4.5 c0.9-0.7,1.9-1.1,3.4-1.1c1.2,0,2.4,0.3,3.3,1.1c1.3,1.1,1.4,2.8,1.4,5h-7.8c0.1,2.5,1.2,3.7,3.3,3.7c1.3,0,2.6-0.3,4.1-0.6v1.5 C239.1,35.4,237.5,35.8,236,35.8 M236.1,25.7c-2.1,0-2.8,1.3-2.9,3.4h5.8C238.9,26.9,238.2,25.7,236.1,25.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M247.5,35.7c-1.1,0-2.3-0.3-3.1-1.2c-1-1.1-1.4-2.6-1.4-4.5c0-1.8,0.5-3.7,1.9-4.7 c1-0.8,2.3-1,3.6-1c0.8,0,1.6,0.1,2.6,0.2v1.6c-0.8-0.1-1.6-0.2-2.4-0.2c-2.6,0-3.6,1.3-3.6,4.1c0,2.5,1,4.1,3.1,4.1 c0.9,0,2.1-0.3,3.1-0.6v1.6C250,35.4,248.7,35.7,247.5,35.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#034EA2"
    },
    points: "98.2,53 98.2,58.8 95.7,58.8 95.7,44.1 105.2,44.1 105.2,46.2 98.2,46.2 98.2,51 104.3,51  104.3,53  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M108.4,58.8V48h2l0.1,0.7c1.5-0.6,2.5-1,3.9-1h0.3v2.1H114c-1,0-1.9,0.2-3.3,0.7v8.4H108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M123.6,58.8l0-0.6c-1.4,0.5-2.6,0.9-4,0.9c-0.9,0-1.8-0.2-2.5-0.9c-0.7-0.6-1-1.4-1-2.5 c0-1.2,0.4-2.3,1.6-2.9c0.8-0.4,1.7-0.5,2.8-0.5c0.8,0,1.9,0,2.8,0.1V52c0-1.9-0.7-2.5-3.1-2.5c-0.9,0-1.9,0.1-2.8,0.2v-1.8 c1-0.1,2.2-0.2,3.2-0.2c1.5,0,3,0.2,4,1c1,0.9,1.1,2.1,1.1,3.6v6.5H123.6z M123.3,54c-0.8-0.1-1.8-0.2-2.5-0.2 c-1.8,0-2.4,0.6-2.4,1.7c0,1,0.7,1.8,2,1.8c0.9,0,1.9-0.3,2.9-0.6V54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M137.5,58.8V52c0-1.8-0.9-2.4-2.4-2.4c-0.8,0-1.8,0.2-2.9,0.7v8.5h-2.3V48h2l0.1,0.6 c1.4-0.4,2.7-0.9,4-0.9c1.2,0,2.3,0.3,3.1,1.2c0.7,0.8,0.9,1.8,0.9,3.1v6.8H137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M147.6,59.1c-1.1,0-2.3-0.3-3.2-1.2c-1-1-1.4-2.6-1.4-4.4c0-1.8,0.5-3.6,1.9-4.7c1-0.8,2.3-1,3.7-1 c0.8,0,1.7,0.1,2.7,0.2v1.9c-0.7-0.1-1.6-0.1-2.4-0.1c-2.4,0-3.4,1.2-3.4,3.8c0,2.3,0.9,3.8,2.9,3.8c0.9,0,2.1-0.3,3.1-0.6v1.8 C150.1,58.7,148.8,59.1,147.6,59.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M158.2,59.1c-1.2,0-2.5-0.3-3.5-1.2c-1-1-1.4-2.6-1.4-4.5c0-1.8,0.4-3.5,1.6-4.6 c0.9-0.8,2-1.1,3.5-1.1c1.2,0,2.5,0.3,3.4,1.1c1.3,1.2,1.5,2.8,1.5,5.1h-7.6c0,2.3,1.1,3.4,3.1,3.4c1.3,0,2.7-0.3,4.1-0.6v1.8 C161.5,58.7,159.8,59.1,158.2,59.1 M158.4,49.2c-1.9,0-2.5,1.2-2.6,3.1h5.3C161,50.3,160.3,49.2,158.4,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M172,59.1c-1.5,0-3.1-0.4-4.2-1.6c-1.4-1.4-1.9-3.5-1.9-6c0-2.4,0.7-4.8,2.5-6.3 c1.4-1.1,3.1-1.3,4.9-1.3c1.1,0,2.2,0.1,3.4,0.2v2.1c-1-0.1-2.2-0.2-3.2-0.2c-3.8,0-5.1,2.1-5.1,5.5c0,3.3,1.4,5.4,4.3,5.4 c1.3,0,2.9-0.4,4.2-0.8v2.1C175.3,58.6,173.6,59.1,172,59.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M181.1,57.9c-1.1-0.9-1.6-2.5-1.6-4.5s0.5-3.6,1.6-4.6c1-0.9,2.3-1.1,3.8-1.1 c1.4,0,2.7,0.3,3.8,1.1c1.1,0.9,1.6,2.5,1.6,4.6c0,2.1-0.5,3.6-1.6,4.6c-1,0.9-2.4,1.1-3.8,1.1C183.5,59.1,182.1,58.8,181.1,57.9  M187.9,53.4c0-2.6-0.9-3.9-3-3.9c-2.2,0-3,1.2-3,3.8c0,2.6,0.9,4,3,4C187.1,57.3,187.9,56.1,187.9,53.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M201.3,58.8V52c0-1.8-0.9-2.4-2.4-2.4c-0.8,0-1.8,0.2-2.9,0.7v8.5h-2.3V48h2l0.1,0.6 c1.4-0.4,2.7-0.9,4-0.9c1.2,0,2.3,0.3,3.1,1.2c0.7,0.8,0.9,1.8,0.9,3.1v6.8H201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M215.5,58.8V52c0-1.8-0.9-2.4-2.4-2.4c-0.8,0-1.8,0.2-2.9,0.7v8.5h-2.3V48h2l0.1,0.6 c1.4-0.4,2.7-0.9,4-0.9c1.2,0,2.3,0.3,3.1,1.2c0.7,0.8,0.9,1.8,0.9,3.1v6.8H215.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M225.8,59.1c-1.2,0-2.5-0.3-3.5-1.2c-1-1-1.4-2.6-1.4-4.5c0-1.8,0.4-3.5,1.6-4.6 c0.9-0.8,2-1.1,3.5-1.1c1.2,0,2.5,0.3,3.4,1.1c1.3,1.2,1.5,2.8,1.5,5.1h-7.6c0,2.3,1.1,3.4,3.1,3.4c1.3,0,2.7-0.3,4.1-0.6v1.8 C229.1,58.7,227.4,59.1,225.8,59.1 M226,49.2c-1.9,0-2.5,1.2-2.6,3.1h5.3C228.5,50.3,227.8,49.2,226,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M238.1,59.1c-1.1,0-2.3-0.3-3.2-1.2c-1-1-1.4-2.6-1.4-4.4c0-1.8,0.5-3.6,1.9-4.7c1-0.8,2.3-1,3.7-1 c0.8,0,1.7,0.1,2.7,0.2v1.9c-0.7-0.1-1.6-0.1-2.4-0.1c-2.4,0-3.4,1.2-3.4,3.8c0,2.3,0.9,3.8,2.9,3.8c0.9,0,2.1-0.3,3.1-0.6v1.8 C240.7,58.7,239.3,59.1,238.1,59.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M248.8,59.1c-1.2,0-2.3-0.4-2.9-1.7c-0.4-0.8-0.5-1.8-0.5-3v-4.6h-1.7V48h1.7l0.3-3.3h2.1V48h3.1 v1.8h-3.1V54c0,0.8,0,1.5,0.2,2c0.2,0.8,0.7,1.1,1.6,1.1c0.5,0,1.1-0.1,1.6-0.2v1.8C250.3,58.9,249.5,59.1,248.8,59.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "18,22 18,56.9 48.2,74.4 78.5,56.9 78.5,22 48.2,4.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M48.2,3.3L17,21.4v36.1l31.3,18l31.3-18V21.4L48.2,3.3z M78.5,56.9L48.2,74.4L18,56.9V22L48.2,4.5 L78.5,22V56.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0069CC"
    },
    points: "62.6,20.8 48.9,12.9 35.2,20.8 25.9,26.2 25.9,26.2 25.9,52.7 25.9,52.7 48.9,66  71.9,52.7 71.9,52.7 71.9,26.2 71.9,26.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#034EA2"
    },
    points: "64.3,39.4 56,25.1 48.9,12.9 48.9,29.6 48.9,66 71.9,52.7 71.9,52.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0069CC"
    },
    points: "56,25.1 64.3,39.4 71.9,26.2 71.9,26.2 62.6,20.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED1C24"
    },
    points: "62.6,20.8 48.9,12.9 56,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0069CC"
    },
    points: "56,25.1 48.9,12.9 56,25.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 24,
    style: {
      fill: "#0069CC"
    },
    width: 0,
    height: 16.6
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED1C24"
    },
    points: "71.9,52.7 71.9,26.2 64.3,39.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED1C24"
    },
    points: "64.3,39.4 71.9,52.7 64.3,39.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0069CC"
    },
    points: "33.6,39.4 41.9,25.1 48.9,12.9 48.9,29.6 48.9,66 25.9,52.7 25.9,52.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED1C24"
    },
    points: "41.9,25.1 33.6,39.4 25.9,26.2 25.9,26.2 35.2,20.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#034EA2"
    },
    points: "35.2,20.8 48.9,12.9 41.9,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0069CC"
    },
    points: "41.9,25.1 48.9,12.9 41.9,25.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7,
    y: 24,
    style: {
      fill: "#0069CC"
    },
    width: 0,
    height: 16.6
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#034EA2"
    },
    points: "25.9,52.7 25.9,26.2 33.6,39.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0069CC"
    },
    points: "33.6,39.4 25.9,52.7 33.6,39.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#034EA2"
    },
    d: "M57.4,42c0.4,0,0.8-0.1,1.2,0c0.3,0.1,0.7,0.1,0.7,0.2c-0.1,0.6-1,0.7-1.4,1.3c-0.1,0-0.1,0-0.2,0 c-0.2,0.1-0.1,0.5-0.3,0.5c-0.2-0.1-0.4,0-0.7,0.1c0.3,0.3,0.7,0.5,1.1,0.4c0.1,0,0.2,0.1,0.2,0.3c0,0,0.1,0,0.1-0.1 c0.1,0,0.1,0,0.1,0.1c0,0.1,0,0.2,0,0.3c-0.2,0.3-0.6,0.2-0.9,0.2c0.6,0.1,1.2,0.1,1.7,0c0.4-0.2,0-0.9,0.3-1.2 c-0.1,0,0-0.2-0.2-0.2c0.1-0.1,0.3-0.4,0.4-0.4c0.1,0,0.4-0.1,0.4-0.2c0-0.1-0.3-0.2-0.2-0.4c0.4-0.3,0.8-0.7,0.6-1.2 c-0.1-0.2-0.7-0.2-1-0.3c-0.4-0.1-0.8,0-1.2,0.1c-0.4,0-0.7,0.2-1.1,0.3c-0.5,0.2-0.9,0.5-1.4,0.8C56.3,42.3,56.8,42.2,57.4,42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M63,46.4c-0.2-0.4-0.5-0.7-0.8-1.1c-0.3-0.5-0.7-0.9-0.8-1.5c-0.2-0.6,0-1.1,0-1.7 c0-1.1-0.3-2.2-0.6-3.2c-0.2-0.5-0.3-1.1-0.5-1.6c-0.1-0.3-0.2-0.6-0.4-0.9c-0.1-0.1-0.1-0.4,0-0.5c0.3-0.2,0.6-0.5,0.8-0.8 c0.2-0.4,0-0.9-0.3-1.1c-0.5-0.2-0.4,0.5-0.8,0.7c-0.1,0-0.1,0-0.2,0c-0.1-0.2,0.1-0.3,0.2-0.4c0-0.1,0-0.2-0.1-0.2 c-0.3,0-0.6-0.1-0.7-0.2c-0.8-1-1.8-1.5-2.9-1.9c0.3,0.1,0.6,0.1,0.9,0.1c0.5,0.1,1.1,0,1.5-0.2c0.4-0.2,0.4-0.7,0.5-1.1 c0.1-0.1,0-0.2,0-0.4c0-0.2-0.2-0.4-0.3-0.6c0,0-0.1-0.1-0.2-0.3c-0.8-0.9-3.9-3.5-9.7-3.1c-2.5,0.2-5.6,0.9-9.2,2.7 c-0.1,0-0.2,0.1-0.4,0.1c-0.6,0.3-1.4,0.8-1.9,1.4c-0.6,0.7-1.1,1.5-1.3,2.4c-0.9,0.6-1.5,1.5-2,2.4c-0.6,1.2-1.4,2.2-1.4,3.5 c0,0.1,0,0.2,0,0.2c0.1,0.4,0.1,0.7,0.2,1.1c0.2,0.8,0.4,1.6,0.5,2.4c0.1,0.4,0.2,0.8,0.3,1.2c0.2,0.4,0,0.9,0.3,1.3 c0.1,0.2,0.1,0.5,0.4,0.6c0,0.1,0,0.2,0,0.3c0.1,0.1,0.1,0.1,0.2,0.1c0,0.1,0,0.2,0,0.3c0.6,0.7,1.3,1.3,1.7,2.1 c0.2,0.4-0.7,0.2-1.1,0.1c-0.7-0.3-1.2-0.9-1.8-1.4c0,0-0.1,0.1-0.1,0.1c0.3,0.5,1.4,1.1,0.8,1.5c-0.3,0.2-0.7-0.2-0.9,0.1 c-0.1,0.1,0,0.3,0,0.4c-0.4-0.3-0.9-0.1-1.3-0.3c-0.3-0.1-0.4-0.6-0.7-0.6c-0.9-0.2-1.8-0.4-2.8-0.4c-0.1,0-0.2,0-0.2,0 c-0.9-0.1-1.8-0.2-2.6-0.1V49c0.8-0.2,1.6-0.4,2.4-0.4c0.1,0,0.2,0,0.2,0c0.2,0,0.5-0.1,0.7,0c-0.3,0-0.7,0-1,0.1 c-0.8,0.1-1.6,0.4-2.4,0.7v1c0.4,0.1,0.9,0.1,1.3,0.2c0.5,0.1,1,0.2,1.5,0.4c0.7,0.2,1.2,0.5,1.8,0.8c0.3,0.2,0.4,0.4,0.7,0.6 c0.4,0.2,0.9,0.2,1.2,0c0.1,0,0.3,0,0.4,0c1.1-0.3,2.2-0.6,2.9-1.5c0,0.1,0.1,0.1,0.1,0.1c-0.2,0.6-0.2,1.2-0.6,1.8 c0,0.1-0.1,0.2,0.1,0.3c0.1,0,0.1,0,0.1,0c-0.1,0-0.1,0-0.1,0.1c0,0.1,0.2,0,0.3,0.1c-0.4,0.1-0.7,0.2-0.9,0.5 c0,0.1,0.1,0.1,0.2,0.1c-0.1,0.1-0.4,0.1-0.4,0.2c0,0,0.1,0.1,0.1,0.1c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0,0.2 c-0.2,0-0.3,0.2-0.4,0.2c0.3,0.2,0.5,0,0.8,0c-0.8,0.3-1.4,0.8-2.2,1c-0.1,0,0,0.2-0.1,0.2c0.2,0.1,0.4-0.1,0.6-0.1 c-0.4,0.3-0.8,0.5-1.2,0.7l2.4,1.4c1-0.6,1.9-1.3,2.7-2.2c0,0,0.1,0.1,0.1,0.1c-0.2,0.7-0.6,1.2-1.2,1.7c-0.4,0.2-0.7,0.6-1,0.7 l1.8,1c0.4-0.3,0.7-0.5,1.2-0.7c0.1,0,0.2,0.1,0.4,0.1c0.6-0.6,1.3-1.3,2.3-1.1c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0 c0,0,0.1,0,0.1-0.1c0,0.1,0,0.1-0.1,0.1c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1,0.1,0,0.1,0.1,0.1c0.4-0.2,0.6-0.4,0.9-0.6 c-0.1,0.1-0.1,0.2-0.1,0.3c-0.9,0.7-1.6,1.4-2.3,2.2l9.5,5.5c0.3-0.4,0.7-1,1.1-1.5c1.8-2.6,4.4-6.1,5.2-6.9 c0.3-0.2,0.6-0.2,1-0.3c1.2,0,2.5,0.3,3.7,0.4c0.1,0,0.3,0.1,0.4,0.1c0.4,0.1,0.9,0,1.4-0.1c0.5-0.2,1.1-0.5,1.3-1.1 c0.2-0.5,0.3-1.1,0-1.6c-0.5-0.6,0.4-0.9,0.7-1.3c0.2-0.4-0.2-0.6-0.2-0.9c-0.1-0.1-0.4-0.1-0.5-0.3c0.5-0.2,1.3-0.7,0.9-1.3 c-0.2-0.4-0.6-0.9-0.2-1.3c0.5-0.3,1.3-0.3,1.5-0.8C64.3,47.8,63.4,47.1,63,46.4z M59.9,42.8c-0.1,0.1,0.2,0.2,0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0,0.2,0.2,0.2c-0.3,0.4,0.2,1.1-0.3,1.2c-0.5,0.2-1.1,0.2-1.7,0 c0.3-0.1,0.7,0.1,0.9-0.2c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0.1-0.1,0.1-0.1,0.1c0-0.1-0.2-0.3-0.2-0.3 c-0.4,0.1-0.8-0.1-1.1-0.4c0.2-0.1,0.4-0.2,0.7-0.1c0.2,0,0.1-0.4,0.3-0.5c0.1,0,0.1,0,0.2,0c0.4-0.6,1.3-0.8,1.4-1.3 c0-0.1-0.4-0.1-0.7-0.2c-0.4-0.1-0.8,0-1.2,0c-0.6,0.2-1.1,0.2-1.6,0.5c0.4-0.3,0.9-0.6,1.4-0.8c0.4-0.1,0.7-0.3,1.1-0.3 c0.4-0.1,0.9-0.2,1.2-0.1c0.4,0.1,0.9,0.1,1,0.3C60.6,42.1,60.3,42.5,59.9,42.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFc);
export default __webpack_public_path__ + "static/media/logo-fc.14a0568aea2d3f488ca796bb7d343506.svg";
export { ForwardRef as ReactComponent };